import cn from 'classnames';

export const ButtonTip = ({ isMobileTooltip, isSmallBorder, tooltipText }) => {
  return (
    <div
      className={cn(
        'absolute bottom-full transform -translate-x-1/2 px-2 py-1 bg-gray-700 rounded-md text-[10px] text-white text-center whitespace-nowrap z-[2]',
        { 'left-[160%] md:left-1/2': isMobileTooltip },
        { 'left-1/2': !isMobileTooltip }
      )}
    >
      {tooltipText}
    </div>
  );
};
